// extracted by mini-css-extract-plugin
module.exports = {"Notification":"Notification_Notification__2nMwM","Active":"Notification_Active__2UDDG","slideUp":"Notification_slideUp__FHFhr"};